<template>
  <div class="animated fadeIn ingreso-egreso-abm">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card>
            <div slot="header">Ingreso/Egreso</div>
            <b-form-group
              label="Personal"
              label-for="personal"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarPersonal">
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="personal"
                  :value="personalNombre"
                  :state="personalValido"
                  readonly
                  type="text"/>
              </b-input-group>
              <b-form-invalid-feedback id="personalFeedback">
                {{ personalInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-ingreso-egreso-tipo
              label="Tipo"
              labelOption="Seleccione un tipo de movimiento"
              :label-cols="labelCols"
              :nombre="ingresoEgresoTipoNombre"
              :valido="ingresoEgresoTipoValido"
              :lista="ingresosEgresosTiposList"
              :msjInvalido="ingresoEgresoTipoInvalidoMsj"
              @validate="validate"
              @updated="ingresoEgresoTipoActualizado">
            </app-ingreso-egreso-tipo>  
          </b-card>
          <b-card>
            <div slot="header">Documentos</div>
            <app-caja
              label="Caja"
              :label-cols="labelCols"
              :nombre="cajaRegistroNombre"
              :valido="cajaRegistroValida"
              :lista="cajasRegistrosList"
              :msjInvalido="cajaRegistroInvalidaMsj"
              @validate="validate"
              @updated="cajaRegistroActualizada">
            </app-caja>  

            <b-form-group
              label="Pesos"
              label-for="pesos"
              :label-cols="2"
              horizontal>
              <b-form-input 
                id="pesos"
                v-model.trim="$v.pesos.$model" 
                :state="pesosValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="pesosFeedback">
                {{ pesosInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="transferenciasEnabled"
              label="Transferencias"
              label-for="transferencias"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="agregarTransferencia">
                  <b-input-group-text>
                    <i class="fa fa-plus"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="transferencias"
                  :value="importeTransferencias | moneda"
                  :readonly="Boolean(true)">
                </b-form-input>
              </b-input-group>

              <b-table hover
                  responsive="sm" 
                  class="cobros-documentos"
                  :busy="tableBusy"
                  :items="transferencias" 
                  :fields="transferenciasFields">

                <template v-slot:cell(fechaCreditoDebito)="data">
                  {{ data.item.fechaCreditoDebito | fecha }}
                </template>
                <template v-slot:cell(importe)="data">
                  {{ data.item.importe | moneda }}
                </template>
                <template v-slot:cell(borrar)="data">
                  <i class="fa fa-remove" @click.stop="borrarTransferencia(data.item)"></i>
                </template>
              </b-table>
            </b-form-group>

            <b-form-group
              v-if="depositosEnabled"
              label="Depositos"
              label-for="depositos"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="agregarDeposito">
                  <b-input-group-text>
                    <i class="fa fa-plus"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="depositos"
                  :value="importeDepositos | moneda"
                  :readonly="Boolean(true)">
                </b-form-input>
              </b-input-group>

              <b-table hover
                  responsive="sm" 
                  class="cobros-documentos"
                  :busy="tableBusy"
                  :items="depositos" 
                  :fields="depositosFields">

                <template v-slot:cell(fechaCreditoDebito)="data">
                  {{ data.item.fechaCreditoDebito | fecha }}
                </template>
                <template v-slot:cell(importe)="data">
                  {{ data.item.importe | moneda }}
                </template>
                <template v-slot:cell(borrar)="data">
                  <i class="fa fa-remove" @click.stop="borrarDeposito(data.item)"></i>
                </template>
              </b-table>
            </b-form-group>

            <b-form-group
              label="Total Documentos"
              label-for="totalDocumentos"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="totalDocumentos"
                :value="totalDocumentos | moneda"
                :readonly="Boolean(true)">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="2"
              horizontal>
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="3"
                max-rows="6"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-card>
          <b-card v-if="cuotasEnabled">
            <div slot="header">
              Descuento del Adelanto
              <!-- <i class="fa fa-plus" @click.prevent="agregarCuota"/> -->
            </div>
            <b-table hover
                class="registro cuotas"
                responsive="sm" 
                :busy="tableBusy"
                :items="cuotas" 
                :fields="cuotasFields">

              <template v-slot:cell(periodo)="data">
                {{ data.item.periodo | periodo }}
              </template>
              <template v-slot:cell(importe)="data">
                {{ data.item.importe | moneda }}
              </template>
              <template v-slot:cell(borrar)="data">
                <i class="fa fa-remove" @click.stop="borrarCuota(data.item)"></i>
              </template>
            </b-table>
            <div class="add-table-btn">
              <div class="list-add-btn" @click.prevent="agregarCuota">
                  <i class="fa fa-plus" aria-hidden="true"></i>
              </div>
            </div>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="searchPersonalModal" 
        title="Seleccionar Personal"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="personal-search-modal">
      <app-search-personal
        @personalSeleccionado="personalSeleccionado">
      </app-search-personal>  
    </b-modal>

    <b-modal ref="cuotaModal" 
        title="Cuota"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-cuota
        @close="closeCuota">
      </app-cuota>
    </b-modal>
    <!-- @ingresoEgresoCuota="ingresoEgresoCuota" -->

    <b-modal ref="addDepositoModal" 
        title="Deposito de Terceros"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-deposito
        @depositoAgregado="depositoAgregado"
        @cancel="depositoCancelado">
      </app-deposito>
    </b-modal>

    <b-modal ref="addTransferenciaModal" 
        title="Transferencias Bancarias"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-transferencia
        :cuentasPesos="true"
        @transferenciaAgregada="transferenciaAgregada"
        @cancel="transferenciaCancelada">
      </app-transferencia>
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Caja from '../shared/abmSelect.vue';
import IngresoEgresoTipo from '../shared/abmSelect.vue';
import SearchPersonal from '../personal/SearchList.vue'
import Cuota from './Cuota.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Deposito from '../bancosmovimientos/Deposito.vue'
// import ChequeTercero from '../chequesterceros/ABMCobro.vue'
import Transferencia from '../bancosmovimientos/Movimiento.vue'
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, decimal, minValue, maxValue, numeric, maxLength } from 'vuelidate/lib/validators';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'ingresoegreso/getField',
  mutationType: 'ingresoegreso/updateField',
});

export default {
  name: 'ABM',
  components: {
    appCaja: Caja,
    appIngresoEgresoTipo: IngresoEgresoTipo,
    appSearchPersonal: SearchPersonal,
    appCuota: Cuota,
    appTransferencia: Transferencia,
    appDeposito: Deposito,
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      personalValido: null,
      personalInvalidoMsj: '',
      ingresoEgresoTipoValido: null,
      ingresoEgresoTipoInvalidoMsj: '',
      cajaRegistroValida: null,
      cajaRegistroInvalidaMsj: '',
      pesosValido: null,
      pesosInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      cajasRegistros: [],
      cajasRegistrosList: [],
      ingresosEgresosTipos: [],
      ingresosEgresosTiposList: [],

      tableBusy: false,
      labelCols: 2,

      depositosFields: [
        { 
          key: 'fechaCreditoDebito',
          label: 'Fecha'
        },
        { 
          key: 'bancoCuentaNombre',
          label: 'Cuenta'
        },
        { key: 'importe' },
        { 
          key: 'borrar',
          label: '',
          class: 'table-remove-icon' 
        },
      ],

      // chequesTercerosFields: [
      //   { key: 'serie' },
      //   { key: 'numero' },
      //   { key: 'importe' },
      //   { 
      //     key: 'borrar',
      //     label: '',
      //     class: 'table-remove-icon' 
      //   },
      // ],

      transferenciasFields: [
        { 
          key: 'fechaCreditoDebito',
          label: 'Fecha'
        },
        { 
          key: 'bancoCuentaNombre',
          label: 'Cuenta'
        },
        { key: 'importe' },
        { 
          key: 'borrar',
          label: '',
          class: 'table-remove-icon' 
        },
      ],

      cuotasFields: [
        { 
          key: 'periodo',
        },
        { key: 'importe' },
        { 
          key: 'borrar',
          label: '',
          class: 'table-remove-icon' 
        },
      ],

      ingresoEgresoCuota: null,
    }
  },
  computed: {
    ...mapFields([
      'id',
      // 'fechaContable',
      'personal',
      'personalNombre',
      'ingresoEgresoTipo',
      'ingresoEgresoTipoNombre',
      'observaciones',
      'pesos',
      'importeTransferencias',
      'transferencias',
      'transferenciasEnabled',
      'importeDepositos',
      'depositos',
      'depositosEnabled',
      'cajaRegistro',
      'cajaRegistroNombre',

      'cuotas',
      'importeCuotas',
      'cuotasEnabled',
    ]),
    totalDocumentos: function() {
      return parseFloat(this.pesos) 
        + parseFloat(this.importeTransferencias)
        + parseFloat(this.importeDepositos);
    },
  },
  created() {
    this.getDatosAdicionales();

    this.$store.dispatch('ingresoegreso/inicializar');
  },  
  methods: {
    getDatosAdicionales() {
      let vm = this;
      vm.$store.dispatch('cajasregistros/getCajasRegistrosSelect')
        .then(() => {
          vm.cajasRegistros = this.$store.getters['cajasregistros/cajasRegistrosSelect'];
          vm.cajasRegistrosList = this.$store.getters['cajasregistros/cajasRegistrosSelectList'];
          return;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de cajas.'));

      vm.$store.dispatch('ingresosegresostipos/getList')
        .then(() => {
          vm.ingresosEgresosTipos = this.$store.getters['ingresosegresostipos/list'];
          vm.ingresosEgresosTiposList = this.$store.getters['ingresosegresostipos/selectList'];
          return;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de tipos de movimiento.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'pesos' || validarTodos) {
        this.pesosValido = null;
        this.pesosInvalidoMsj = this.displayErrorMonto (this.$v.pesos.$error, 
          this.$v.pesos.decimal, this.$v.pesos.minValue); 
        
        if (this.pesosInvalidoMsj.trim() != '') {
          this.pesosValido = false;
        }
      }

      if (campo == "observaciones" || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo pueden contener hasta 5000 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    displayErrorMonto( fieldError, fieldErrorDecimal, fieldErrorMinValue) {
      let errorMsj = '';
      if (fieldError) {
        if (fieldErrorDecimal) {
          errorMsj = 'El monto ingresado debe ser un valor numérico';
        } else if (fieldErrorMinValue) {
          errorMsj = 'El monto ingresado no es válido';
        }
      }
      return errorMsj;
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      let personalError = true;
      if (this.personal) {
        if (this.personal.id) {
          if (this.personal.id != 0) {
            personalError = false;
          }
        }
      }
      if (personalError) {
        save = Boolean(false);
        this.personalValido = false;
        this.personalInvalidoMsj = "Debe seleccionar el personal correspondiente.";
      }

      let ingresoEgresoTipoError = true;
      if (this.ingresoEgresoTipo) {
        if (this.ingresoEgresoTipo.id) {
          if (this.ingresoEgresoTipo.id != 0) {
            ingresoEgresoTipoError = false;
          }
        }
      }
      if (ingresoEgresoTipoError) {
        save = Boolean(false);
        this.ingresoEgresoTipoValido = false;
        this.ingresoEgresoTipoInvalidoMsj = "Debe seleccionar el tipo de movimiento correspondiente.";
      }

      let cajaRegistro;
      if (this.cajaRegistroNombre) {
        cajaRegistro = this.getSelected(this.cajasRegistros, this.cajaRegistroNombre);
      }
      this.$store.dispatch('ingresoegreso/setCajaRegistro', cajaRegistro);

      let cajaRegistroError = true;
      if (this.cajaRegistro) {
        if (this.cajaRegistro.id) {
          if (this.cajaRegistro.id != 0) {
            cajaRegistroError = false;
          }
        }
      }
      if (cajaRegistroError) {
        save = Boolean(false);
        this.cajaRegistroValida = false;
        this.cajaRegistroInvalidaMsj = "Debe seleccionar la caja correspondiente.";
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('ingresoegreso/save')
            .then( () => this.showModalMsj ('El movimiento se registró con éxito.', this.goList, this.goList, 'light'))
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goList() {
      this.$router.push({ name: 'IngresosEgresos' });
    },
    goBack() {
      this.$router.push({ name: 'IngresosEgresos' });
    },
    seleccionarPersonal() {
      this.$refs.searchPersonalModal.show()
    },
    personalSeleccionado(item) {
      this.$refs.searchPersonalModal.hide();
      this.$store.dispatch('ingresoegreso/setPersonal', item);
    },

    agregarDeposito(){
      this.$refs.addDepositoModal.show();
    },
    depositoAgregado(deposito){
      this.$refs.addDepositoModal.hide();
      this.$store.dispatch('ingresoegreso/setDeposito', deposito)
        .catch( error => this.showErrorMsj (error));
    },
    depositoCancelado(){
      this.$refs.addDepositoModal.hide();
    },
    borrarDeposito(item){
      this.$store.dispatch('ingresoegreso/deleteDeposito', item)
        .catch( error => this.showErrorMsj (error));
    },

    agregarTransferencia(){
      this.$refs.addTransferenciaModal.show();
    },
    transferenciaAgregada(transferencia){
      this.$refs.addTransferenciaModal.hide();
      this.$store.dispatch('ingresoegreso/setTransferencia', transferencia)
        .catch( error => this.showErrorMsj (error));
    },
    transferenciaCancelada(){
      this.$refs.addTransferenciaModal.hide();
    },
    borrarTransferencia(item){
      this.$store.dispatch('ingresoegreso/deleteTransferencia', item)
        .catch( error => this.showErrorMsj (error));
    },

    agregarCuota(){
      this.$refs.cuotaModal.show();
    },
    closeCuota(cuota){
      this.$refs.cuotaModal.hide();
      if (cuota) {
        this.$store.dispatch('ingresoegreso/addCuota', cuota)
          .catch( error => this.showErrorMsj (error));
      }
    },
    borrarCuota(item){
      this.$store.dispatch('ingresoegreso/deleteCuota', item)
        .catch( error => this.showErrorMsj (error));
    },

    cajaRegistroActualizada(nombre) {
      this.cajaRegistroNombre = nombre;
      
      if ( this.cajaRegistroNombre ) {
        this.cajaRegistroValida = null;
        this.cajaRegistroInvalidaMsj = '';
      }
    },
    ingresoEgresoTipoActualizado(nombre) {
      if (this.ingresoEgresoTipoNombre != nombre) {
        this.ingresoEgresoTipoNombre = nombre;
        
        let ingresoEgresoTipo;
        if (this.ingresoEgresoTipoNombre) {
          ingresoEgresoTipo = this.getSelected(this.ingresosEgresosTipos, this.ingresoEgresoTipoNombre);
        }

        this.$store.dispatch('ingresoegreso/setIngresoEgresoTipo', ingresoEgresoTipo)
          .catch( error => this.showErrorMsj (error));

        if (this.ingresoEgresoTipo.id != 0) {
          this.ingresoEgresoTipoValido = null;
          this.ingresoEgresoTipoInvalidoMsj = '';
        }

      }
    },
  },
  validations: {
    pesos: { decimal, minValue: minValue(0) },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
}
</script>

<style>
  .ingreso-egreso-abm .registro.cuotas table td[aria-colindex="1"] {
    width: 40%;
  }
  .ingreso-egreso-abm .registro.cuotas table td[aria-colindex="2"] {
    width: calc(60% - 40px);
  }
  .ingreso-egreso-abm .registro.cuotas table td[aria-colindex="3"] {
    width: 40px;
  }

</style>
